import * as mainTerms from '../../mainTerms';
const advertiserDef = mainTerms.Setting.advertiser.default;

export const advertiser = {
    name: {
        label: advertiserDef + ' 이름',
        placeholder: '이름을 입력해주세요',
        error: {
            required: '이름을 입력해주세요',
        },
    },
    description: {
        label: advertiserDef + ' 설명',
        placeholder: '상세 설명을 입력해주세요',
    },
}